import { createContext, useContext } from 'react'

import { AuthContextType } from 'auth/types'

export const authContextDefaultValue = {
  user: null,
  charlieUser: null,
  jwt: null,
  isLoading: false,
  isAuthenticated: false,
}

// Create context with default value
export const AuthContext = createContext<AuthContextType>({
  ...authContextDefaultValue,
  logout: () => {},
  verifyCurrentToken: async () => false,
  refreshCurrentToken: async () => false,
})

export const useAuthContext = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  return context
}
